// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/task',
    name: 'Task',
    component: layout,
    redirect: '/task/index',
    meta: {
      title: '任务',
      i18Key: 'router.user.task.title',
      roles: [1]
    },
    sort: 0,
    children: [
      {
        path: 'index',
        name: 'TaskIndex',
        component: () => import('@/views/Task/Index.vue'),
        meta: {
          constantLight: true,
          title: '任务',
          icon: 'i-menu:task',
          i18Key: 'router.user.task.index',
          roles: [1]
        }
      },
      {
        path: 'history',
        name: 'TaskHistory',
        component: () => import('@/views/Task/History.vue'),
        hiddenInMenu: true,
        meta: {
          title: '任务历史',
          icon: 'i-menu:task',
          i18Key: 'router.user.task.index',
          roles: [1]
        }
      },
      {
        path: 'promptUseDetail',
        name: 'PromptUseDetail',
        component: () => import('@/views/Task/PromptUseDetail.vue'),
        hiddenInMenu: true,
        meta: {
          title: 'Prompt使用情况',
          icon: 'i-menu:task',
          i18Key: 'router.user.task.index',
          roles: [1]
        }
      }
    ]
  }
]
export default routes
